<div class="integrations-page">
  <div class="integrations-page__title">
    <h2 class="vox-heading-2" translate>integrations.title</h2>
  </div>
  <hr />
  <div class="integrations-page__filters-container">
    <gdp-integrations-filters (filtersChanged)="filterChanged($event)" [platforms]="platforms"></gdp-integrations-filters>
  </div>
  <div class="integrations-page__table-container">
    <gdp-integrations-table [authMethodsType]="authMethodsType" [integrations]="integrations" [loading]="loading" [context]="'global'"></gdp-integrations-table>
    <gdp-table-pagination *ngIf="integrations?.length !== 0" (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)"
      [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize">
    </gdp-table-pagination>
  </div>
</div>